import { Clock3 } from "lucide-react";
import { Reveal, ChapterTag } from "./Reveal";
import { scrollToSection } from "../lib/scroll";

export const Preise = () => (
    <section id="preise" data-testid="preise-section" className="py-24 sm:py-32 lg:py-40 bg-[#EFECE4]">
        <div className="max-w-6xl mx-auto px-5 sm:px-8 lg:px-12">
            <Reveal>
                <ChapterTag number="05" label="Preise" />
                <h2 className="font-serif font-light text-3xl sm:text-5xl tracking-tight text-[#2B2825]">
                    Individuelle Begleitung
                </h2>
                <p className="mt-6 max-w-2xl font-sans text-base sm:text-lg font-light leading-relaxed text-[#59534C]">
                    Im kostenlosen Kennenlerngespräch können wir zunächst schauen, ob mein Angebot zu dir passt.
                    Danach entscheidest du, ob und wann du einen Beratungstermin vereinbaren möchtest.
                </p>
            </Reveal>

            <div className="mt-16 grid md:grid-cols-3 gap-px bg-[#CFC7B8] border border-[#CFC7B8]">
                <Reveal className="h-full">
                    <div
                        data-testid="price-card-erstgespraech"
                        className="relative bg-[#FAF8F5] p-9 sm:p-12 h-full flex flex-col"
                    >
                        <p className="font-sans text-[11px] font-medium tracking-[0.25em] uppercase text-[#5E6B5A] mb-6">
                            Empfohlener Einstieg
                        </p>
                        <h3 className="font-serif font-medium text-2xl sm:text-3xl text-[#2B2825]">Kennenlerngespräch</h3>
                        <p className="font-serif font-light text-4xl sm:text-5xl text-[#2B2825] mt-5">Kostenlos</p>
                        <p className="font-sans text-sm font-light text-[#8C8275] mt-2 flex items-center gap-1.5">
                            <Clock3 size={14} strokeWidth={1.5} /> ca. 15–20 Minuten
                        </p>
                        <p className="mt-6 font-sans text-sm sm:text-base font-light leading-relaxed text-[#59534C]">
                            Wir lernen uns unverbindlich kennen und schauen gemeinsam, ob mein Angebot zu deiner
                            Situation passt. Ohne Verpflichtung.
                        </p>
                        <button
                            data-testid="price-btn-kennenlernen"
                            onClick={() => scrollToSection("#kontakt")}
                            className="mt-auto pt-8"
                        >
                            <span className="block w-full bg-[#2B2825] text-[#FAF8F5] font-sans text-[12px] font-medium tracking-[0.15em] uppercase px-6 py-4 hover:bg-[#4A453F] transition-colors duration-300 text-center">
                                Kennenlerngespräch anfragen
                            </span>
                        </button>
                    </div>
                </Reveal>

                <Reveal delay={0.12} className="h-full">
                    <div
                        data-testid="price-card-einzelberatung"
                        className="bg-[#F4F1EA] p-9 sm:p-12 h-full flex flex-col"
                    >
                        <p className="font-sans text-[11px] font-medium tracking-[0.25em] uppercase text-[#8C8275] mb-6">
                            Beratung
                        </p>
                        <h3 className="font-serif font-medium text-2xl sm:text-3xl text-[#2B2825]">Einzelberatung</h3>
                        <p className="font-serif font-light text-4xl sm:text-5xl text-[#2B2825] mt-5">
                            CHF 90
                        </p>
                        <p className="font-sans text-sm font-light text-[#8C8275] mt-2 flex items-center gap-1.5">
                            <Clock3 size={14} strokeWidth={1.5} /> 60 Minuten
                        </p>
                        <p className="mt-6 font-sans text-sm sm:text-base font-light leading-relaxed text-[#59534C]">
                            Ein vertrauliches Gespräch zu den Themen, die für dich gerade wichtig sind. Du entscheidest,
                            wie oft weitere Gespräche sinnvoll sind.
                        </p>
                    </div>
                </Reveal>

                <Reveal delay={0.2} className="h-full">
                    <div
                        data-testid="price-card-studierende"
                        className="bg-[#EFECE4] p-9 sm:p-12 h-full flex flex-col"
                    >
                        <p className="font-sans text-[11px] font-medium tracking-[0.25em] uppercase text-[#8C8275] mb-6">
                            Beratung ermässigt
                        </p>
                        <h3 className="font-serif font-medium text-2xl sm:text-3xl text-[#2B2825]">Studierende & Schüler:innen</h3>
                        <p className="font-serif font-light text-4xl sm:text-5xl text-[#2B2825] mt-5">
                            CHF 60
                        </p>
                        <p className="font-sans text-sm font-light text-[#8C8275] mt-2 flex items-center gap-1.5">
                            <Clock3 size={14} strokeWidth={1.5} /> 60 Minuten
                        </p>
                        <p className="mt-6 font-sans text-sm sm:text-base font-light leading-relaxed text-[#59534C]">
                            Ermässigter Preis für Schüler:innen, Lernende und Studierende – gleiche Beratung, gleiche Dauer.
                        </p>
                    </div>
                </Reveal>
            </div>

            <Reveal delay={0.2}>
                <p className="mt-10 font-sans text-sm sm:text-base font-medium leading-relaxed text-[#2B2825]">
                    Die Beratung wird nicht über die Krankenkasse abgerechnet, da es sich nicht um eine Psychotherapie handelt.
                </p>
            </Reveal>
        </div>
    </section>
);
